import ScreenUserLogin from 'screens/User/Login';
import Dashboard from 'layouts/Dashboard';
import { USER } from './paths';

const indexRoutes = [
  {
    path: USER.LOGIN,
    name: 'Login',
    component: ScreenUserLogin,
    loginRequired: false,
  },
  { path: '/', name: 'Dashboard', component: Dashboard, loginRequired: true },
];

export default indexRoutes;
